import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { Async } from '../../../components/AsyncProvider';
import { Button } from '../../../components/Button';
import { Loading } from '../../../components/Loading/index';
import { ProjectList } from '../../../components/ProjectList';
import { IAsyncData } from '../../../models';
import { ROUTES } from '../../../router/consts';
import { IApplicationState } from '../../../store/models';
import { Container } from '../../Layout/components/Container/index';
import { setHeaderColor } from '../../Layout/store/actions';
import { ETextColor } from '../../Projects/enums';
import { getHomeAction } from '../store/actions';
import { IHomeState } from '../store/models';
import { BrandingText } from './BrandingText';
import { CustomersList } from './Customers';
import { MainCarousel } from './MainCarousel/index';

import './index.scss';

export const HomePage: React.FC = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const homePageBranch = useSelector<IApplicationState, IAsyncData<IHomeState>>((state) => state.home);

    React.useEffect(
        () => {
            dispatch(setHeaderColor(ETextColor.WHITE));
            dispatch(getHomeAction());
        },
        [dispatch]
    );

    return (
        <>
            <Helmet>
                <title>SCOUT - Home</title>
            </Helmet>
            <Async
                branch={homePageBranch}
                deps={[homePageBranch]}
                successRender={(data) => (
                    <>
                        <MainCarousel projects={data.slider} />
                        <BrandingText />
                        <CustomersList partners={data.partners} />
                        <Container>
                            <ProjectList projects={data.projects} />
                            <div className="show_more">
                                <Button onClick={() => history.push(ROUTES.PROJECTS)}>More projects</Button>
                            </div>
                        </Container>
                    </>
                )}
                loadingRender={() => <Loading />}
            />
        </>
    );
};
